import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_CIVILBUDGET,
  DELETE_CIVILBUDGET,
  UPDATE_CIVILBUDGET,
  ADD_NEW_CIVILBUDGET,
} from "./actionType";

import {
  getCivilBudgetSuccess,
  getCivilBudgetFail,
  deleteCivilBudgetSuccess,
  deleteCivilBudgetFail,
  updateCivilBudgetSuccess,
  updateCivilBudgetFail,
  addCivilBudgetSuccess,
  addCivilBudgetFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getCivilBudgetApi,
  updateCivilBudgetApi,
  deleteCivilBudgetApi,
  addNewCivilBudgetApi,
  approveCivilBudgetApi
} from "../../helpers/backend_helper";

function* getCivilBudget({ payload: civilBudget }) {
  try {
    const response = yield call(getCivilBudgetApi, civilBudget);
    yield put(getCivilBudgetSuccess(GET_CIVILBUDGET, response.data));
  } catch (error) {
    yield put(getCivilBudgetFail(GET_CIVILBUDGET, error));
  }
}

function* onUpdateCivilBudget({ payload: civilBudget }) {
  try {
    if (civilBudget.setApprove) {
      const response = yield call(approveCivilBudgetApi, civilBudget);
      yield put(updateCivilBudgetSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateCivilBudgetApi, civilBudget);
      yield put(updateCivilBudgetSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateCivilBudgetFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteCivilBudget({ payload: civilBudget }) {
  try {
    const response = yield call(deleteCivilBudgetApi, civilBudget);
    yield put(deleteCivilBudgetSuccess({ civilBudget, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteCivilBudgetFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewCivilBudget({ payload: civilBudget }) {
  try {
    const response = yield call(addNewCivilBudgetApi, civilBudget);
    yield put(addCivilBudgetSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addCivilBudgetFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetCivilBudget() {
  yield takeEvery(GET_CIVILBUDGET, getCivilBudget);
}

export function* watchUpdateCivilBudget() {
  yield takeEvery(UPDATE_CIVILBUDGET, onUpdateCivilBudget);
}

export function* watchDeleteCivilBudget() {
  yield takeEvery(DELETE_CIVILBUDGET, onDeleteCivilBudget);
}

export function* watchAddNewCivilBudget() {
  yield takeEvery(ADD_NEW_CIVILBUDGET, onAddNewCivilBudget);
}

function* civilBudgetSaga() {
  yield all([
    fork(watchGetCivilBudget),
    fork(watchDeleteCivilBudget),
    fork(watchUpdateCivilBudget),
    fork(watchAddNewCivilBudget)
  ]);
}

export default civilBudgetSaga;
